import { Suspense, lazy, useEffect, useState } from "react";
import { Accordion, Badge, Button, Card, Col, Dropdown, Modal, Table } from "react-bootstrap"

import { Link } from "react-router-dom";
import swal from "sweetalert";
import Pagination from "react-js-pagination";
import EventBus from "../../../../services/EventBus.js"
import { GetAllExams, GetAllTenants, deleteexams, generatequestions } from "../../../../services/CommonService.js";
import { ToastContainer, toast } from "react-toastify";
import ViewExamQuestions from "./ViewExamQuestions.js";

const AddExam = lazy(() => import('./AddExam.js'));
function Exams() {
    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const [exams, setExams] = useState([])
    const [postModal, setPostModal] = useState(false);
    const [activePage, setActivePage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0)
    const [updatedata, setUpdateData] = useState({});
    const [viewdata, setViewData] = useState({});
    const [tenantlist, setTenantList] = useState([]);
    const [viewModal,setViewModal]=useState(false)
    const [subadminbar, setSubAdminbar] = useState(true);
    const svg1 = (
        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                <circle fill="#000000" cx="19" cy="12" r="2"></circle>
            </g>
        </svg>
    );
    useEffect(() => {
        getAllExams()
        getTenants()

        EventBus.on("loadpagedata", (data) => {
            let obj = {
                payload: {
                    "pageNo": data?.message?.page,
                    "size": 10
                }
            }
            loadData(data?.message?.page);
            //dispatch(fetchAllPaitentsForMedicalBoard({obj:obj}));
        });
        EventBus.remove("loadpagedata");

        const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
        if (constuserdetails?.roles[0] == 'ROLE_SUBADMIN') {
            setSubAdminbar(false)
        }
    }, [])

    const handlePageChange = async (pn) => {
        if (pn !== activePage && !isNaN(pn)) {
            loadNextsetofRecords(pn);
        }
    };
    const loadNextsetofRecords = async (pn) => {
        setActivePage(pn);
        EventBus.dispatch("loadpagedata", {
            message: {
                "page": pn
            }

        });
    };

    const loadData = async (pn) => {

        const reqparams = {
            pageno: pn
        }
        const respData = await GetAllExams(reqparams);
        setExams(respData.data.docs)
        setTotalRecords(respData.data.totalDocs);
    }

    const getAllExams = async () => {
        const reqparams = {
            pageno: 1,
            query: { status: "Active" }
        }
        const ResponseData = await GetAllExams(reqparams)
        setExams(ResponseData?.data?.docs)
        setTotalRecords(ResponseData.data.totalDocs);
        // console.log("Exams response", ResponseData.data.docs);
    }

    const getTenants = async () => {

        const reqdata = {
            pageno: '-1',
            query: { status: 'Active' }
        }

        const Response = await GetAllTenants(reqdata)
        let counter = 0;
        const rowdata = [];
        await Response.data.reduce(async (promise, res) => {
            await promise;
            const opts = {
                label: res.name,
                value: res.tenantid
            }
            rowdata.push(opts);
            if (counter == Response.data.length - 1) {

                setTenantList(rowdata);
            }
            counter++;
        }, Promise.resolve());

    }

    const addModal = async () => {
        setUpdateData({})
        setPostModal(true)

    }

    const closemodal = async () => {
        getAllExams()
        setPostModal(false);
    }
    const openModal = async (item) => {
        setUpdateData(item);
        setPostModal(true);
    }
    const deleteItem = async (item) => {
        const Response = await deleteexams(item);
        // console.log("Delete resp",Response.data);
        if (Response.data?.id) {
            notifyTopFullWidth("Data deleted successfully");
            getAllExams()
        }

    }

    const generateQuestions=async(item)=>{
       const Response=await generatequestions(item)
       if(Response.data=="Failure"){
        notifyTopFullWidth(Response.message)
       }
       else{
        notifyTopFullWidth("Questions generated Succesfully")
       }
       
    }

    const viewQuestionsModal=async(item)=>{
      
        setViewData(item)
        setViewModal(true)

    }

    const closeviewmodal=async()=>{
        setViewModal(false)
    }


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Card>
                <Card.Header>
                    <Card.Title>Exams <Button onClick={() => addModal()}
                        className="me-2" variant="primary btn-square"
                        title="Add Exams"
                    >
                        <span className="btn-icon-start text-danger">
                            <i className="fa fa-plus color-danger" />
                        </span>
                        ADD
                    </Button></Card.Title>
                </Card.Header>
                <Card.Body>
                    <Table responsive>
                        <thead>
                            <tr>
                                <th className="width80">
                                    <strong>Display Order</strong>
                                </th>
                                <th>
                                    <strong>Exam Name</strong>
                                </th>
                                <th>
                                    <strong>Tenant</strong>
                                </th>
                                <th>
                                    <strong>College</strong>
                                </th>
                                <th>
                                    <strong>Total questions</strong>
                                </th>
                                {/* <th>
                                    <strong>Topic</strong>
                                </th> */}
                                <th>
                                    <strong>Duration</strong>
                                </th>

                                <th>
                                    <strong>Exam type</strong>
                                </th>
                                <th>
                                    <strong>Status</strong>
                                </th>

                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {exams?.map(item => (
                                <tr key={item.id}>
                                    <td>
                                        <strong>{item.position}</strong>
                                    </td>
                                    <td>{item.examname}</td>
                                    <td>{displayTenants(item.tenant)}</td>
                                    <td>{displayTenants(item.area)}</td>
                                    <td>{item.totalquestions}</td>
                                    <td>{item.duration}</td>
                                    {/* <td></td> */}
                                    <td>{item.examtype}</td>
                                    <td>{item.status}</td>
                                    <td></td>

                                    <td>
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant="success"
                                                className="light sharp i-false"
                                            >
                                                {svg1}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => openModal(item)}>
                                                    Edit

                                                </Dropdown.Item >

                                               {subadminbar && <Dropdown.Item onClick={() => deleteItem(item)}>

                                                    Delete

                                                </Dropdown.Item >}

                                                <Dropdown.Item onClick={() => generateQuestions(item)}>

                                                Generate Questions

                                                </Dropdown.Item >
                                                <Dropdown.Item onClick={()=>viewQuestionsModal(item)}>
                                                    View Questions
                                                </Dropdown.Item>


                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>
                    <div >

                        <Pagination
                            activePage={activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                            activeClass="active"
                            itemClass="page-item"
                            innerClass="pagination mb-0"
                            linkClass="page-link"
                            firstPageText="First"
                            lastPageText="Last"
                            prevPageText="Previous"
                            nextPageText="Next"
                            disabledClass="disabled"
                            activeLinkClass="disabled"
                        />
                    </div>
                </Card.Body>

            </Card>

            <Modal className="modal fade" size="xl" show={postModal} onHide={setPostModal} >
                <div className="" role="document">
                    <div className="">
                        <form >
                            <div className="modal-header">

                                <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">


                                <Suspense fallback={<div>Loading</div>}>
                                    <AddExam updateprop={updatedata} tenantprops={tenantlist} />
                                </Suspense>


                            </div>

                        </form>

                    </div>
                </div>
            </Modal>

            <Modal className="modal fade" size="xl" show={viewModal} onHide={setViewModal} >
                <div className="" role="document">
                    <div className="">
                        <form >
                            <div className="modal-header">

                                <button type="button" className="btn-close" onClick={closeviewmodal} data-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">

                            <Suspense fallback={<div>Loading</div>}>
                                <ViewExamQuestions viewprop={viewdata}/>
                                   
                                </Suspense>

                            </div>

                        </form>

                    </div>
                </div>
            </Modal>

        </>
    )

    function displayTenants(item) {


        let counter = 0;
        let retdata = '';
        for (var j = 0; j < item.length; j++) {
    
          // console.log(item[j]);
          if (retdata == '') {
            retdata = item[j].label;
          } else {
            retdata = retdata + ',' + item[j].label;
          }
          if (counter == item.length - 1) {
            return retdata;
          }
    
          counter++;
    
        }
      }
}

export default Exams